import { IconSystemV2CourseVolume2 } from '@doltech/icons/SystemV2/IconSystemV2CourseVolume2';
import { observer } from 'mobx-react-lite';
import * as React from 'react';
import styled from 'styled-components';

import { useSimpleAudioPlayInBackgroundStore } from '../../../hooks/simple-audio-play-in-background.store';

export const ButtonIconAudioMain = styled.div`
  cursor: pointer;

  &:hover {
    transform: scale(1.1);
  }
  &:active {
    transform: scale(0.9);
  }
`;

interface ButtonIconAudioProps {
  textToPlayAudio: string;
}

export const ButtonIconAudio = observer(({ textToPlayAudio }: ButtonIconAudioProps) => {
  const audioStore = useSimpleAudioPlayInBackgroundStore();

  return (
    <ButtonIconAudioMain
      onClick={() => {
        audioStore.playByText(textToPlayAudio);
      }}
      aria-hidden
      className="btn-audio"
    >
      <IconSystemV2CourseVolume2 color="blue100" size={32} />
    </ButtonIconAudioMain>
  );
});
